export const limeScale = {
    DEFAULT: '#A2D80E',
    light: '#DEFA91',
    dark: '#89B80A',
    100: '#EEFEC2',
    200: '#DEFA91',
    300: '#C3F342',
    400: '#A2D80E',
    500: '#89B80A',
    600: '#5B7906',
    700: '#425705',
    800: '#2F3F03',
    900: '#212C02',
    1000: '#161D02'
};
export const greenScale = {
    DEFAULT: '#1AA33E',
    light: '#ABF8BF',
    dark: '#1AA33E',
    100: '#CFFCDB',
    200: '#ABF8BF',
    300: '#84EBA0',
    400: '#50D975',
    500: '#1AA33E',
    600: '#1A7F34',
    700: '#0C5A21',
    800: '#074016',
    900: '#052E10',
    1000: '#04200C'
};
export const cyanScale = {
    DEFAULT: '#76D6F9',
    light: '#AFE9FD',
    dark: '#3EBEED',
    100: '#CCF1FF',
    200: '#AFE9FD',
    300: '#76D6F9',
    400: '#3EBEED',
    500: '#289EC9',
    600: '#0A749B',
    700: '#044E69',
    800: '#03374A',
    900: '#022B3B',
    1000: '#021D27'
};
export const skyScale = {
    DEFAULT: '#4290F5',
    light: '#8EBDFB',
    dark: '#4290F5',
    100: '#D3E5FD',
    200: '#BAD7FD',
    300: '#8EBDFB',
    400: '#5FA1F7',
    500: '#4290F5',
    600: '#1C65C4',
    700: '#0E438A',
    800: '#063066',
    900: '#05244D',
    1000: '#031833'
};
export const indigoScale = {
    DEFAULT: '#3F52D5',
    light: '#A0ACF8',
    dark: '#3F52D5',
    100: '#D8DDFD',
    200: '#CAD0FC',
    300: '#A0ACF8',
    400: '#7F8EF5',
    500: '#6073EB',
    600: '#3F52D5',
    700: '#253498',
    800: '#132176',
    900: '#0C165A',
    1000: '#070E40'
};
export const purpleScale = {
    DEFAULT: '#9460DC',
    light: '#D9C1FA',
    dark: '#763CC8',
    100: '#E7D8FD',
    200: '#D9C1FA',
    300: '#BF98F6',
    400: '#A97AEB',
    500: '#9460DC',
    600: '#763CC8',
    700: '#521F99',
    800: '#3A1173',
    900: '#2B0A57',
    1000: '#1E0642'
};
export const pinkScale = {
    DEFAULT: '#E250BB',
    light: '#FBB6E9',
    dark: '#B82E93',
    100: '#FDD1F1',
    200: '#FBB6E9',
    300: '#F58AD8',
    400: '#EA66C7',
    500: '#E250BB',
    600: '#B82E93',
    700: '#7C1861',
    800: '#5B0B46',
    900: '#410631',
    1000: '#2F0423'
};
export const magentaScale = {
    DEFAULT: '#BC246A',
    light: '#F792C0',
    dark: '#811345',
    100: '#FDD1E5',
    200: '#FBBBD8',
    300: '#F792C0',
    400: '#ED6EA7',
    500: '#DF498D',
    600: '#BC246A',
    700: '#811345',
    800: '#5C0A2F',
    900: '#450823',
    1000: '#2F0417'
};
//# sourceMappingURL=single_hue_color.js.map